import { scrollTo } from '../utilities';

($ => {

	const fixedClass = 'fixed';
	const $siteHeader = $('#site-header');
	const $pageHeader = $('.page-header');
	const $anchorNav = $('.fullWidthHero-anchorNavItems');

	if( $siteHeader && $anchorNav ) {
		const isAnchorNavFixed = () => {
			try {
				const siteHeaderHeight = $siteHeader.outerHeight();
				const anchorNavHeight = $anchorNav.outerHeight();
				const pageHeaderHeight = $pageHeader.outerHeight();
				const scrollTop = $(document).scrollTop();

				return scrollTop + siteHeaderHeight >= pageHeaderHeight - anchorNavHeight;
			} catch( error ) {
				console.log( error );

				return false;
			}
		};

		const applyFixedClass = () => {
			if( isAnchorNavFixed() ) {
				$anchorNav.css( 'top', $siteHeader.outerHeight() ).addClass( fixedClass );
			} else {
				$anchorNav.css( 'top', '' ).removeClass( fixedClass );
			} 
		}

		if( $('body.page-template-template-full_width_hero').size() ) {
			$( document ).ready( applyFixedClass );
			$( window ).resize( applyFixedClass );
			$( window ).scroll( applyFixedClass );
		}

		$('.fullWidthHero-anchorNavItem').off( 'click' );
		$('.fullWidthHero-anchorNavItem').click( event => {
			event.preventDefault();

			const $targetElement = $( $( event.currentTarget ).attr( 'href' ) );
			const offset = $anchorNav.outerHeight() * -1;

			scrollTo( $targetElement, 500, { offset });
		});
	}

})(jQuery);



// WEBPACK FOOTER //
// ../benetech/js/templates/full-width-hero.js